import asyncStorageKeys from "./asyncStorageKeys";

// localStorage utility functions for web application
export const getToken = async () => {
  try {
    return window.localStorage.getItem(asyncStorageKeys.TOKEN) || null;
  } catch (error) {
    console.error('Error getting token from localStorage:', error);
    return null;
  }
};

export const saveToken = async (token) => {
  try {
    window.localStorage.setItem(asyncStorageKeys.TOKEN, token);
    return true;
  } catch (error) {
    console.error('Error setting token in localStorage:', error);
    return false;
  }
};

export const clearToken = async (token) => {
  try {
    window.localStorage.removeItem(asyncStorageKeys.TOKEN, token);
    return true;
  } catch (error) {
    console.log('Error removing token in localStorage:', error);
    return false;
  }
};

export const saveUserId = async (token) => {
    try {
      window.localStorage.setItem(asyncStorageKeys.USER_ID, token);
      return true;
    } catch (error) {
      console.error('Error setting user_id in localStorage:', error);
      return false;
    }
  };

export const getUserId = async () => {
  try {
    return window.localStorage.getItem(asyncStorageKeys.USER_ID) || null;
  } catch (error) {
    console.error('Error getting USER_ID from localStorage:', error);
    return null;
  }
};

export const clearUserId = async (token) => {
  try {
    window.localStorage.removeItem(asyncStorageKeys.USER_ID, token);
    return true;
  } catch (error) {
    console.log('Error removing user_id in localStorage:', error);
    return false;
  }
};

export const saveUserType = async (token) => {
    try {
      window.localStorage.setItem(asyncStorageKeys.USER_TYPE, token);
      return true;
    } catch (error) {
      console.error('Error setting user_type in localStorage:', error);
      return false;
    }
  };

export const getUserType = async () => {
  try {
    return window.localStorage.getItem(asyncStorageKeys.USER_TYPE) || null;
  } catch (error) {
    console.error('Error getting USER_TYPE from localStorage:', error);
    return null;
  }
};

export const clearUserType = async (token) => {
  try {
    window.localStorage.removeItem(asyncStorageKeys.USER_TYPE, token);
    return true;
  } catch (error) {
    console.log('Error removing user_type in localStorage:', error);
    return false;
  }
};
